/** Reads finished translations aloud with the browser's speech synthesis. */

import { speechTag } from "./languages.ts";

export class ReadAloud {
  private spoken = new Set<string>();
  private enabled = false;

  static get supported(): boolean {
    return typeof window !== "undefined" && "speechSynthesis" in window;
  }

  setEnabled(on: boolean): void {
    this.enabled = on && ReadAloud.supported;
    if (!this.enabled && ReadAloud.supported) window.speechSynthesis.cancel();
  }

  /** Speak a segment's final translation once. Segments seen while disabled are skipped. */
  offer(id: string, text: string, lang: string): void {
    if (this.spoken.has(id)) return;
    this.spoken.add(id);
    if (!this.enabled || !text) return;
    const utterance = new SpeechSynthesisUtterance(text);
    const tag = speechTag(lang);
    utterance.lang = tag;
    const voice = window.speechSynthesis.getVoices().find((v) => v.lang.toLowerCase().startsWith(tag));
    if (voice) utterance.voice = voice;
    window.speechSynthesis.speak(utterance);
  }

  reset(): void {
    this.spoken.clear();
    if (ReadAloud.supported) window.speechSynthesis.cancel();
  }
}
